<template>
    <input
        type="text"
        ref="inputRef"
        :value="modelValue"
        class="w-full"
        :class="[props.borderless ? 'border-none focus:border-none focus:outline-none focus:ring-0' : '']"
    />
</template>

<script setup>
    import { onMounted, ref } from 'vue';

    const props = defineProps({
        modelValue: String,
        borderless: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits(['update:modelValue', 'latlng']);

    const inputRef = ref(null);

    onMounted(async () => {
        // Wait for Google Maps to load
        await window.googleMapsReady;
        
        const autocomplete = new google.maps.places.Autocomplete(inputRef.value, {
            types: ['(cities)'],
            fields: ['geometry', 'formatted_address'],
            componentRestrictions: { country: ['ca'] },
        });

        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();

            if (!place) {
                return;
            }

            emit('update:modelValue', place.formatted_address);

            if (place.geometry && place.geometry.location) {
                emit('latlng', {
                    city: place.formatted_address,
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                });
            }
        });
    });
</script>
